export default __webpack_public_path__ + "static/media/CapaAddtoGroup.7d9ac07a.svg";